import { createSlice } from "@reduxjs/toolkit";

export const customerInfoSlice = createSlice({
  name: "customerInfo",
  initialState: {
    authData: { authToken: null, isAuthenticated: false },
    userData: null,
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
    },
  },
});

export const { saveAuthData, saveUserData } = customerInfoSlice.actions;

export default customerInfoSlice.reducer;
